import { TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  () => ({
    root: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      gridTemplateRows: '1fr 1fr',
      gridGap: Spacings.s4,
      marginTop: Spacings.s56,

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        gridTemplateColumns: '1fr 1fr',
      },
    },
    item: {
      minWidth: Spacings.s0,
      aspectRatio: 1,
      '& > div': {
        width: '100%',
        height: '100%',
      },
    },
    title: {
      marginTop: Spacings.s56,
      marginBottom: Spacings.s8,
      fontSize: FontSizes.s8,
      lineHeight: LineHeights.l24,
      textAlign: 'center',
      color: TextColors.base,

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        fontSize: FontSizes.s16,
      },
    },
    // skeleton styles
    skeletonWrapper: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      gridTemplateRows: '1fr 1fr',
      gridGap: Spacings.s8,

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        gridTemplateColumns: '1fr 1fr',
      },
    },
    skeletonItem: {
      minWidth: Spacings.s0,
      aspectRatio: 1.5,
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
    skeletonTitle: {
      display: 'flex',
      justifySelf: 'center',
      height: Spacings.s24,
      maxWidth: 100,
      margin: 'auto',
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      marginTop: Spacings.s56,
      marginBottom: Spacings.s24,
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        fontSize: FontSizes.s16,
      },
    },
  }),
  {
    name: 'brands-grid',
  },
);

export default useStyles;
